import { request } from './default'
import { useAuthStore } from '@/store'


export async function loginRequest(email: string, password: string) {
  const store = useAuthStore();
  
  return request({
    url: 'api/auth/login',
    method: 'POST',
    data: {
      password,
      email,
      method: store.authMethod.toLowerCase(),
    },
  }).catch((e) => {
    // setAuthRequestFinished(true)
    throw e
  })
}

export function loginWithSSORequest() {
  return request({
    url: 'auth/redirect',
    method: 'GET',
  })
}

export async function getAuthenticatedProfileRequest() {
  return request({
    url: '/api/profile',
  }).catch((e) => {
    // setAuthRequestFinished(true)
    throw e
  })
}

export function sendForgotPasswordRequest(email: string) {
  return request({
    url: '/api/authentication/password/request',
    method: 'POST',
    data: { email },
  })
}

export function sendResetPasswordRequest(
  token: string,
  password: string,
  password_confirmation: string,
) {
  return request({
    url: '/api/authentication/password/request',
    method: 'PATCH',
    data: { token, password, password_confirmation },
  })
}
